import { createAction, props } from '@ngrx/store';

export const resetLayout = createAction('[Layout] Reset layout');

export const updateFullScreenLayout = createAction(
  '[Layout] Update Full Screen Layout',
  props<{
    payload: {
      fullScreen: boolean;
    };
  }>()
);

export const updateUseMobileLayout = createAction(
  '[Layout] Update Use Mobile Layout',
  props<{
    payload: {
      useMobileLayout: boolean;
    };
  }>()
);
